<template>
  <b-modal id="game-modal-menu" v-model="modal" size="md" hide-footer centered>
    <h2 class="text-center">RULETAS</h2>
    <div class="menu-container mt-4">
      <vs-button
        v-for="(game, i) in roulettes"
        :key="i"
        @click="openVideo(game.url)"
      >
        {{ game.name }}
      </vs-button>
    </div>
    <modal-video ref="modalVideo"></modal-video>
  </b-modal>
</template>

<script>
import ModalVideo from '../../../../components/ModalVideo.vue';

export default {
  components: {
    ModalVideo,
  },
  data() {
    return {
      modal: false,
      roulettes: [
        {
          name: 'SPRINT',
          url: 'https://sprintgaming.club/',
        },
      ]
    };
  },
  methods: {
    openVideo(url) {
      this.$refs.modalVideo.videoUrl = url;
      this.$refs.modalVideo.modal = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
